import React from 'react';
import { Card, WarningOutlineIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { ICON_TYPES } from "./utils";
var cx = classNames.bind(styles);
export var SupportInfoListIcon = function SupportInfoListIcon(_ref) {
  var type = _ref.type;
  var Icon = ICON_TYPES[type] || WarningOutlineIcon;
  return /*#__PURE__*/React.createElement(Card, {
    className: cx('icon-wrapper'),
    "data-t-id": "components-SupportInfoListIcon"
  }, /*#__PURE__*/React.createElement(Icon, {
    fill: "#1790FF",
    size: 24,
    "data-t-id": "components-SupportInfoListIcon"
  }));
};